import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, Redirect } from "react-router-dom";
import PinInput from "react-pin-input";

import yourSquadHeadline from "../assets/headlines/your-squad.png";

import { Squad } from "../components/Squad";
import WithMotion from "../utils/withMotion";
import scss from "./YourSquad.module.scss";

const YourSquad = () => {
  const { squadSubmission } = useSelector((state: any) => state);
  const [pin, setPin] = useState("");
  const history = useHistory();
  const { squad } = squadSubmission;

  useEffect(() => {
    const inputs = document.querySelectorAll(".pincode-input-text");
    inputs.forEach((input) => {
      input.setAttribute("placeholder", "*");
    });
  }, [pin]);

  const pinError = pin.length === 4 && pin !== "1966";

  try {
    const pinEntered = localStorage.getItem("pinEntered");
    if (pinEntered) {
      return <Redirect to="/timer" />;
    }
  } catch (err) {
    console.log(err);
  }

  const handleSubmit = () => {
    try {
      localStorage.setItem("pinEntered", Date.now().toString());
    } catch (err) {
      console.log(err);
    }
    history.push("/timer");
  };

  return (
    <main>
      <img className={scss.headline} src={yourSquadHeadline} alt="your squad" />
      
      <div className={`${pinError ? scss.pinError : ""}`}>
        <Squad squad={squad} />
        <p className={scss.almostThere}>
        Your picks are in and you’re<br/>entered for a chance to win.</p>

        <p className={scss.tip}>
          <b>To unlock your results:</b>
          <br />
          Head to your local IMAX theater and enter 
          <br />
          the <b>4 digit code</b> displayed on screen at 
          <br />
          the start of The Suicide Squad showing.*
        </p>

        <PinInput
          length={4}
          initialValue={pin}
          focus
          inputMode="numeric"
          type="numeric"
          onChange={(value) => setPin(value)}
        />
        <button
          className="roundedButton"
          disabled={pin !== "1966"}
          onClick={handleSubmit}
        >
          {pin === "1966"
            ? "CONTINUE"
            : pin.length === 4
            ? "INVALID CODE"
            : "ENTER CODE"}
        </button>
        <p className={scss.noPurchaseNecessary}>
          *No purchase or IMAX Screening necessary to enter the sweepstakes.
          Code is not required to receive a sweepstakes entry.
        </p>
      </div>
    </main>
  );
};


export default WithMotion(YourSquad);
